
import TheDocumentList from "@/components/documents/TheDocumentList.vue";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "DocumentsUser",
  components: { TheDocumentList },
});
